import { HTMLAttributes, TextareaHTMLAttributes } from 'react';
import { joinClassNames } from '../../../utils';
import { OmitClassName } from '../../../types';
import { Label } from '../Label';
import styles from '../styles.module.scss';

export type TextAreaProps = HTMLAttributes<HTMLTextAreaElement> & {
  id: string;
  label: string;
  hideLabel?: boolean;
  isRequired?: boolean;
} & OmitClassName<TextareaHTMLAttributes<HTMLTextAreaElement>>;

export const TextArea = ({ id, label, hideLabel = false, isRequired = false, ...props }: TextAreaProps) => (
  <>
    <Label htmlFor={id} isRequired={isRequired} hidden={hideLabel}>
      {label}
    </Label>
    <textarea id={id} className={joinClassNames(styles.textArea, !hideLabel && styles.hasLabel)} {...props} />
  </>
);
